import type { MissingHandler } from 'vue-i18n';

export type MissingTranslationPayload = {
  locale: string;
  key: string;
  type?: string;
};

type MissingTranslationHandlerOptions = {
  onMissing: (payload: MissingTranslationPayload) => void;
};

/**
 * Vue I18n `missing` handler that notifies via `onMissing` and returns the key as fallback text.
 */
export function createMissingTranslationHandler(
  options: MissingTranslationHandlerOptions,
): MissingHandler {
  return (locale, key, _instance, type) => {
    options.onMissing({
      locale: String(locale),
      key: String(key),
      ...(type !== '' ? { type: String(type) } : {}),
    });
    return String(key);
  };
}
